export const round = (n: number, places = 1): number => Math.round(10 ** places * n) / 10 ** places;
export const trunc = (n: number, places = 1): number => Math.trunc(10 ** places * n) / 10 ** places;
